// SPDX-License-Identifier: AGPL-3.0-or-later

import {useExpressionImagePreload} from '@app/features/expressions/utils/ExpressionImageCache';
import type React from 'react';

type ReactionImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
	src: string;
};

export const ReactionImage: React.FC<ReactionImageProps> = ({src, decoding = 'async', loading = 'eager', ...props}) => {
	useExpressionImagePreload(src);
	return <img src={src} decoding={decoding} loading={loading} {...props} />;
};
